"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Container = _interopRequireDefault(require("../components/Container"));

var _PageHeader = _interopRequireDefault(require("../components/PageHeader"));

var _lock = _interopRequireDefault(require("@wisetack/assets/img/lock.svg"));

var _AccountLockedPageModule = _interopRequireDefault(require("./AccountLockedPage.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AccountLockedPage = function AccountLockedPage() {
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_PageHeader["default"], {
    progress: ""
  }, /*#__PURE__*/_react["default"].createElement("div", null, "Account locked"), /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement("img", {
    className: _AccountLockedPageModule["default"].lock,
    src: _lock["default"],
    alt: "lock"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _AccountLockedPageModule["default"].message
  }, "You've reached the maximum number of failed login attempts, so your account is temporarily locked. Please try again in\xA0an\xA0hour."), /*#__PURE__*/_react["default"].createElement("div", {
    className: _AccountLockedPageModule["default"].message
  }, "For assistance or questions, contact ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "mailto:support@wisetack.com"
  }, "support@wisetack.com")));
};

var _default = AccountLockedPage;
exports["default"] = _default;